import { CREATE_FAQ_FAILURE, CREATE_FAQ_INIT, CREATE_FAQ_SUCCESS } from '@store/action-types/faq';
import Client from '@api-sdk/client';
import { set, toPath, isEmpty } from 'lodash';
import { enqueueSnackbar } from '@store/actions/toast';
import translateToastMessage from '@shared/utils/translateToastMessage';
import history from '@store/history';
import ROUTES from '@shared/consts/routes';

const createFaqInit = () => ({ type: CREATE_FAQ_INIT });
const createFaqSuccess = () => ({ type: CREATE_FAQ_SUCCESS });
const createFaqFailure = error => {
  if (!error?.errors) {
    return { type: CREATE_FAQ_FAILURE, payload: { error } };
  }

  const mappedErrors = error?.errors?.reduce?.((acc, item) => {
    const path = toPath(item.context)?.filter(
      key => key !== 'children' && key !== 'data' && key !== 'pl' && key !== 'en',
    );
    set(acc, path, item.code?.split?.(':')?.pop?.() || item.message);
    return acc;
  }, {});

  return { type: CREATE_FAQ_FAILURE, payload: { error: mappedErrors } };
};

const createFaq = ({ faqData, saveAndBack = false }) => async dispatch => {
  dispatch(createFaqInit());

  if (isEmpty(String(faqData?.position))) {
    return dispatch(createFaqFailure({ position: 'POSITION_IS_REQUIRED' }));
  }

  try {
    const faqResponse = await Client.createFaq({ data: faqData });

    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('faq.create'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'success',
        },
      }),
    );

    if (saveAndBack) {
      history.push(ROUTES.FAQ);
    } else {
      history.push(`/faq/${faqResponse.response?.id}`);
    }

    return dispatch(createFaqSuccess());
  } catch (error) {
    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('faq.error.create'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'error',
        },
      }),
    );
    return dispatch(createFaqFailure(error));
  }
};

export default createFaq;
